import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import { filterRoutes } from "@/utils/permission";
import { asyncRoutes } from "@/router/asyncRoutes";

Vue.use(ElementUI);

//消息弹窗封装引入
import messageUtils from "./utils/messageUtils";
Vue.prototype.$message = messageUtils;

//引用富文本编辑器
import VueQuillEditor from "vue-quill-editor";
//引入富文本css
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
//富文本编辑器添加实例
Vue.use(VueQuillEditor);

//main.js中引入全局函数，定义调用 使用this.函数名
import publicFun from "./utils/publicFun";
Vue.use(publicFun);

Vue.config.productionTip = false;

// 刷新页面时恢复动态路由（在 Vue 实例创建前执行）
async function restoreDynamicRoutes() {
  const token = sessionStorage.getItem("access_token");
  if (!token) return false;

  //权限按钮
  const buttonIds = sessionStorage.getItem("buttonIds");
  store.commit("setUserPermissions", JSON.parse(buttonIds));

  const permissionsStr = sessionStorage.getItem("user_permissions");
  if (!permissionsStr) return false;

  const permissions = JSON.parse(permissionsStr);
  const accessedRoutes = filterRoutes(asyncRoutes, permissions);

  accessedRoutes.forEach((route) => {
    router.addRoute("Dashboard", route);
  });
  const homeMenu = {
    path: "/home",
    name: "Home",
    meta: { title: "首页", icon: "el-icon-s-home", permission: "home" },
  };
  const menuTree = [homeMenu, ...accessedRoutes];
  store.commit("permission/SET_MENU_LIST", menuTree);

  return true;
}

// 恢复完成后再启动 Vue 应用
restoreDynamicRoutes().finally(() => {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
});
